import { useState, useEffect } from 'react';

const useTablet = () => {
    const [isTablet, setIsTablet] = useState(false);

    useEffect(() => {
        if (window.innerWidth >= 769 && window.innerWidth <= 1024) {
            setIsTablet(true);
        }
    }, []);

    return isTablet;
}

export default useTablet;